import { render, staticRenderFns } from "./ContactsFragmentDesktopContactListEmployees.vue?vue&type=template&id=153642a2&"
import script from "./ContactsFragmentDesktopContactListEmployees.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopContactListEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports